import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from 'react-redux';

import * as integrationActions from "../../redux/Integration/actions.js";
import constants from "../../utils/constants.js";

import PageBase from "../../components/PageBase";
import PopupWin from "../../components/PopupWin";
import * as ROUTES from "../../utils/routes";
import "./integrations.scss";
import settingsIcon from "../../assets/integrations/settings-icon.svg";
import salesforceLogo from "../../assets/integrations/salesforce-logo.png";
import hubspotLogo from "../../assets/integrations/hubspot.png";
import image131 from "../../assets/integrations/image-131.png";
import image133 from "../../assets/integrations/image-133.png";
import arrow1 from "../../assets/integrations/arrow-1.svg";
import arrow2 from "../../assets/integrations/arrow-2.svg";
import arrow3 from "../../assets/integrations/arrow-3.svg";

const Integrations = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [searchQuery, setSearchQuery] = useState("");
  const [categoryFilter, setCategoryFilter] = useState("All");
  const [statusFilter, setStatusFilter] = useState("All");
  const [showConnectModal, setShowConnectModal] = useState(false);
  const [selectedIntegration, setSelectedIntegration] = useState(null);
  const [getConnectUrlLoading, setGetConnectUrlLoading] = useState(false);

  // Mock data - replace with actual data from API
  const [integrations, setIntegrations] = useState([
    {
      id: 1,
      name: "Salesforce",
      vendor: "Salesforce",
      description: "The global leader in customer relationship and RevOps.",
      category: "CRM",
      status: "",
      logo: salesforceLogo,
      commingSoon: false,
    },
    {
      id: 2,
      name: "HubSpot",
      vendor: "HubSpot",
      description: "A unified CRM platform for marketing, sales, and CS.",
      category: "CRM",
      status: "",
      logo: hubspotLogo,
      commingSoon: false,
    },
  ]);


  const handleConnect = (vendor) => {
    setGetConnectUrlLoading(true);
    dispatch(integrationActions.getConnectUrl({ vendor, redirectUri: window.location.origin + ROUTES.HUBSPOT_INTEGRATION + '?integration_connected=true' }, (result) => {
      setGetConnectUrlLoading(false);

      const url = result?.url;

      if (url) {
        let menuData = localStorage.getItem(constants.MENU_DATA);
        try {
          menuData = JSON.parse(menuData);
        } catch (error) {
        }

        const openCategory = menuData ? menuData?.openCategory : null;
        const route = ROUTES.HUBSPOT_INTEGRATION + '?integration_connected=true';
        localStorage.setItem(constants.MENU_DATA, JSON.stringify({openCategory, route}));
        window.location.href = url;
      }
    }));
  };

  useEffect(() => {
    // Fetch my connections
    dispatch(integrationActions.getMyconnection((result) => {
      if (result) {
        const connection = result;
        const vendor = connection?.crm_vendor;

        const integration = integrations.find((item) => item.vendor === vendor);

        if (integration) {
          setIntegrations((prevIntegrations) =>
            prevIntegrations.map((item) =>
              item.vendor === vendor
                ? { 
                    ...item, 
                    status: connection?.crm_status,
                  }
                : item
            )
          );
        }
      }
    }));
  }, [dispatch]);

  const handleInstallSalesforce = () => {
    let menuData = localStorage.getItem(constants.MENU_DATA);
    try {
      menuData = JSON.parse(menuData);
    } catch (error) {
    }

    const openCategory = menuData ? menuData?.openCategory : null;
    const route = ROUTES.SALESFORCE_INTEGRATION;
    localStorage.setItem(constants.MENU_DATA, JSON.stringify({openCategory, route}));

    navigate(route);
  };

  const filteredIntegrations = integrations.filter((integration) => {
    const matchesSearch =
      integration.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      integration.description.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesCategory =
      categoryFilter === "All" || integration.category === categoryFilter;
    const matchesStatus =
      statusFilter === "All" || integration.status === statusFilter;
    return matchesSearch && matchesCategory && matchesStatus;
  });

  return (
    <PageBase title="Integrations" removeMargins>
      <div className="integrations-container">
        <div className="integrations-controls">
          <div className="filter-dropdown">
            <span>Category: </span>
            <select
              value={categoryFilter}
              onChange={(e) => setCategoryFilter(e.target.value)}
            >
              <option value="All">All</option>
              <option value="CRM">CRM</option>
              <option value="Marketing">Marketing</option>
              <option value="Analytics">Analytics</option>
            </select>
            <svg
              className="dropdown-icon"
              width="7.47"
              height="4.2"
              viewBox="0 0 8 5"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 1L4 4L7 1"
                stroke="#142A31"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>

          <div className="filter-dropdown">
            <span>Status: </span>
            <select
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
            >
              <option value="All">All</option>
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option>
            </select>
            <svg
              className="dropdown-icon"
              width="7.47"
              height="4.2"
              viewBox="0 0 8 5"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 1L4 4L7 1"
                stroke="#142A31"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>

          <div className="search-container">
            <svg
              className="search-icon"
              width="13"
              height="13"
              viewBox="0 0 13 13"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5.5 10C7.98528 10 10 7.98528 10 5.5C10 3.01472 7.98528 1 5.5 1C3.01472 1 1 3.01472 1 5.5C1 7.98528 3.01472 10 5.5 10Z"
                stroke="#88ABB4"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M12 12L8.5 8.5"
                stroke="#88ABB4"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <input
              type="text"
              className="search-input"
              placeholder="Search Integrations..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>
        </div>

        <div className="integrations-grid">
          {filteredIntegrations.map((integration) => (
            <div key={integration.id} className="integration-card">
              {integration.logo && (
                <div className="integration-logo-container">
                  <img
                    src={integration.logo}
                    alt={integration.name}
                    className="integration-logo"
                  />
                </div>
              )}

              <h3 className="integration-name">{integration.name}</h3>
              <p className="integration-description">
                {integration.description}
              </p>

              <div className="integration-footer">
                <div className="integration-tags">
                  <span className="category-tag">{integration.category}</span>
                  {Boolean(integration.commingSoon) === true && (
                    <span className="coming-soon-tag">Coming Soon</span>
                  )}
                  
                  {integration.status === "connected" && (
                    <button
                      className="status-tag active settings-tag"
                      aria-label="Settings"
                      onClick={() => {
                        // Navigate to integration detail page based on integration name
                        if (integration.vendor === "HubSpot") {
                          navigate(ROUTES.HUBSPOT_INTEGRATION);
                        }
                      }}
                    >
                      {integration.status}
                      <img src={settingsIcon} alt="Settings" />
                    </button>
                  )}
                </div>

                {(!integration.status || integration.status !== 'connected') && Boolean(integration.commingSoon) === false && (
                  <button
                    className="connect-button"
                    onClick={() => {
                      if (integration.vendor === 'Salesforce') {
                        handleInstallSalesforce();
                        return;
                      }

                      setSelectedIntegration(integration);
                      setShowConnectModal(true);
                    }}
                  >
                    {integration?.vendor === 'HubSpot' ? 'Connect' : 'Install'}
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>

      {selectedIntegration && (
        <PopupWin
          visible={showConnectModal}
          onClose={() => {
            setShowConnectModal(false);
          }}
          hideClose={false}
          popupStyle={{
            width: "427px",
            minHeight: "295px",
            padding: 0,
            background: "#ffffff",
            borderRadius: "10px",
            boxShadow: "0px 9px 25px 0px rgba(129, 155, 163, 0.27)",
          }}
          contentStyle={{
            padding: "38px 85px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
          }}
          className="connect-modal"
        >
          <div className="connect-modal-content">
            <h2 className="connect-modal-title">
              Connect {selectedIntegration.name}
            </h2>
            <p className="connect-modal-description">
              You'll be redirected to {selectedIntegration.name} to connect your
              account
            </p>
            <div className="connect-modal-flow">
              <img
                src={image131}
                alt="Step 1"
                className="connect-modal-flow-image-left"
              />
              <div className="connect-modal-flow-arrows">
                <img src={arrow1} alt="Arrow" className="connect-modal-arrow" />
                <img src={arrow2} alt="Arrow" className="connect-modal-arrow" />
                <img src={arrow3} alt="Arrow" className="connect-modal-arrow" />
              </div>
              <img
                src={image133}
                alt="Step 2"
                className="connect-modal-flow-image-right"
              />
            </div>
            <div className="connect-modal-button-container">
              <button
                className="connect-modal-button"
                disabled={getConnectUrlLoading}
                onClick={() => {
                  handleConnect(selectedIntegration.vendor);
                }}
              >
                {getConnectUrlLoading ? "Connecting..." : "Connect"}
              </button>
            </div>
          </div>
        </PopupWin>
      )}
    </PageBase>
  );
};

export default Integrations;
